// File: chatbot-landing-page/src/utils/chatUtils.js

export const focusChatbot = (iframeElementOrId) => {
  let iframeElement = iframeElementOrId;

  // If an ID string is passed, try to get the element
  if (typeof iframeElementOrId === 'string') {
    iframeElement = document.getElementById(iframeElementOrId);
  }

  if (iframeElement && iframeElement.contentWindow) {
    // IMPORTANT: Replace 'https://rag.lucycuts.workers.dev' with your chatbot UI's actual origin
    // This is the targetOrigin for postMessage
    iframeElement.contentWindow.postMessage('focusChatInput', 'https://rag.lucycuts.workers.dev');
    console.log('Focus message sent to chatbot iframe via focusChatbot utility.');

    // Optional: Scroll the iframe into view if it's not already
    iframeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true; // Indicate success
  } else {
    console.log('Chatbot iframe not found or not accessible via focusChatbot utility.');
    return false; // Indicate failure
  }
}; 